module.exports = __webpack_public_path__ + "img/facebook.2ef32593.svg";